import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import React, { useEffect } from 'react';
import { EditorWrapper } from '@/components/ui/RichTextEditor/RichTextEditor.styled.ts';

interface RichTextEditorProps {
  value: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement> | { target: { name: string; value: string } },
  ) => void;
  name: string;
  placeholder?: string;
}

const RichTextEditor: React.FunctionComponent<RichTextEditorProps> = ({
  value,
  onChange,
  name,
}) => {
  const editor = useEditor({
    extensions: [StarterKit],
    content: value || '<p></p>',
    editorProps: {
      attributes: {
        class: 'focus:outline-none',
      },
    },
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onChange({
        target: {
          name: name,
          value: html,
        },
      });
    },
  });

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value || '<p></p>');
    }
  }, [value, editor]);

  if (!editor) {
    return null;
  }

  return (
    <EditorWrapper>
      <EditorContent editor={editor} />
    </EditorWrapper>
  );
};

export default RichTextEditor;
